<div class="topbar-wrapper">
  <div class="input-searchbar-container">
    <div class="input-wrapper">
      <input
      #searchBarInput
      type="text"
      class="input-label solid"
      placeholder="Search for something..."
      />
      <i
        class="input-icon ic-search"
        *ngIf="!searchBarInput?.value; else clearButton"
      ></i>
      <ng-template #clearButton>
        <button type="button" class="btn btn-cancel input-icon" (click)="clear()">
          <i class="ic-remove"></i>
        </button>
      </ng-template>
    </div>
    <div class="searchbar-overlay" *ngIf="searchValue" (click)="closeSearchBar()"></div>
    <div class="searchbar-container" *ngIf="searchValue">
      <div class="searchbar-group-container" *ngFor="let entity of entityList" >
        <ng-container *ngIf="entity.searchBarResponses.length > 0">
          <label class="category">{{entity.name | titlecase}}</label>
          <a
            *ngFor="let itemFound of entity?.searchBarResponses"
            routerLink="/{{itemFound.link}}"
            class="entity-container"
            (click)="getEnteredValue(itemFound)">
            <div class="container-img">
              <img class='entity-img' [src]="getIcon(itemFound.type, itemFound.toolName)" [alt]="itemFound.type + ' ' + itemFound.toolName">
              <span *ngIf="itemFound.type === 'project'" class="chart">{{itemFound.name.charAt(0) | uppercase}}</span>
            </div>
            <div class="entity-info-wrapper">
              <div class="entity-info-container">
                <p class="entity-name">
                  <span>{{itemFound.name}}</span>
                  <i class="ic-fav-on" *ngIf="itemFound.isBookmarked"></i>
                </p>
                <p class="details-info">{{itemFound.details}}</p>
              </div>
              <i class="ic-chevron-right"></i>
            </div>
          </a>
        </ng-container>
      </div>
        <p *ngIf="searchBarInput?.value && entityList?.length === 0">No results</p>
    </div>
  </div>
  <div class="user-group pl-5">
    <!-- <i class="ic-help icon"></i> -->
    <div class="notification-wrapper">
      <i class="ic-notification icon mx-3" (click)="openNotificationsModal()"></i>
      <div class="badge" *ngIf="user?.new_notification"></div>
    </div>
    <div ngbDropdown class="dropdown">
      <button class="dropdown avatar-btn" ngbDropdownToggle id='dropdownMenuButton'>
        <img class="icon rounded-circle" [src]="user?.thumbnail | authImage | async">
      </button>
      <div ngbDropdownMenu class="dropdown-menu dropdown-right profile" aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item" routerLink="/profile/{{user?.id}}/">
          <img class="action-icon rounded-circle profile-img" [src]="user?.thumbnail | authImage | async">
          <div>
            <p class="name">{{ user?.name}} {{user?.surname}}</p>
            <p class="email">{{ user?.mail | slice : 0:20}}</p>
          </div>
        </a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item profile-item" routerLink="/profile/{{user?.id}}/notification">
          <i class="ic-settings action-icon" alt=""></i>
          Preferences
        </a>
        <a class="dropdown-item error" (click)='logout()'>
          <i class="ic-logout action-icon" alt=""></i>
          Logout
        </a>
      </div>
    </div>
  </div>
</div>
